import uniqueId from 'lodash/uniqueId';
import $ from 'jquery';
export default class Pattern{
  init(container){
    $('.pattern',container).each((i,e)=>{
      const id= uniqueId('pattern_');
      $(e).find('pattern').attr('id',id);
      $(e).find('rect').attr('fill',`url(#${id})`);
    });
  }
}
